// C:\Users\sergi\kadosh\kadosh-frontend\src\pages\usuarioNovo\UsuarioNovo.tsx

import { useState } from "react";
import Button from "../../components/button/Button";
import InputText from "../../components/inpuText/InputText";
import styles from "./UsuarioNovo.module.css";

interface UsuarioNovoProps {
    onSubmit: (nome: string) => void;
}

const UsuarioNovo = ({ onSubmit }: UsuarioNovoProps) => {
    // Estado para armazenar o valor digitado no input
    const [nome, setNome] = useState("");

    const handleAtivar = () => {
        // Evita envio de string vazia ou apenas com espaços
        if (nome.trim() !== "") {
            onSubmit(nome.trim());
        }
    };

    return (
        <div className={styles.container}>
            <h1>
                Bem-vindo(a) ao seu
                <br />
                elo digital da fé
            </h1>
            <span>
                Para personalizarmos sua experiência diária, por favor, diga-nos
                seu primeiro nome.
            </span>
            <InputText
                placeholder="Qual o seu nome?"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
            />
            {/* O botão fica desabilitado caso o usuário não tenha digitado nada */}
            <Button onClick={handleAtivar} disabled={nome.trim() === ""}>
                Ativar minha pulseira
            </Button>
        </div>
    );
};

export default UsuarioNovo;
